import { render, staticRenderFns } from "./catalogList.vue?vue&type=template&id=9d1ee962&scoped=true&"
import script from "./catalogList.vue?vue&type=script&lang=js&"
export * from "./catalogList.vue?vue&type=script&lang=js&"
import style0 from "./catalogList.vue?vue&type=style&index=0&id=9d1ee962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1ee962",
  null
  
)

export default component.exports